import { motion } from "framer-motion";
import { Receipt, PlusCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

interface ExpenseHeaderProps {
  onAddNew: () => void;
}

export const ExpenseHeader = ({ onAddNew }: ExpenseHeaderProps) => {
  const handleAddNew = () => {
    try {
      onAddNew();
    } catch (error) {
      console.error("Error adding new expense:", error);
      toast.error("Failed to add new expense. Please try again.");
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 mb-6 bg-gradient-to-r from-blue-50 to-blue-100 p-4 rounded-lg"
    >
      <div className="flex items-center gap-3">
        <Receipt className="h-6 w-6 text-blue-500" />
        <div>
          <h2 className="text-xl md:text-2xl font-bold text-gray-800">Expenses</h2>
          <p className="text-sm text-gray-600">Track and manage your trip expenses</p>
        </div>
      </div>
      <Button
        onClick={handleAddNew}
        className="w-full md:w-auto flex items-center gap-2 bg-blue-500 hover:bg-blue-600 transition-all"
      >
        <PlusCircle className="h-4 w-4" />
        Add New Expense
      </Button>
    </motion.div>
  );
};